import { Form, DatePicker, Button, Divider, Row, Col, Card, Input } from "antd";
import moment from "antd/node_modules/moment";
import React from "react";

export interface FiltersBarType {
  filters: any;
  children?: any;
  actions?: any;
  actionsSpan?: number;
  cfg: {
    showSearchBtn?: boolean;
    showResetBtn?: boolean;
    showPeriod?: boolean;
    periodLabel?: string;
    showKeyword?: boolean;
  };
  refresh: () => void;
  reset: (values) => void;
  search: () => void;
  setFilters?: (filters: any) => void;
}

export const FiltersBar = ({
  search,
  refresh,
  reset,
  setFilters,
  filters,
  cfg,
  children,
  actions,
  actionsSpan,
}: FiltersBarType) => {
  const { showSearchBtn = true, showResetBtn = true, periodLabel, showPeriod = true, showKeyword = true } = cfg;

  const onPeriod = (e) => {
    console.log(e);
    setFilters?.({ ...filters, period: e });
  };

  const onKeyword = (keyword) => {
    setFilters?.((prev) => ({ ...prev, keyword }));
  };

  return (
    <Card size="small" className="fm-filter-bar" bodyStyle={{ paddingBottom: 0 }}>
      <Form size="small" initialValues={filters}>
        <Row gutter={24}>
          {showPeriod && (
            <Col span={8}>
              <Form.Item label={periodLabel}>
                <DatePicker.RangePicker
                  allowClear
                  style={{ width: "100%" }}
                  value={filters.period}
                  onChange={(e) => onPeriod(e)}
                  ranges={{
                    Today: [moment(), moment()],
                    "This Week": [moment().startOf("week"), moment().endOf("week")],
                    "This Month": [moment().startOf("month"), moment().endOf("month")],
                    "This Year": [moment().startOf("year"), moment().endOf("year")],
                  }}
                />
              </Form.Item>
            </Col>
          )}
          {children}
          {showKeyword && (
            <Col span={8}>
              <Form.Item label="Keyword">
                <Input.Search value={filters.keyword} onChange={(e) => onKeyword(e.target.value)} />
              </Form.Item>
            </Col>
          )}
          {actionsSpan && (
            <Col span={actionsSpan} style={{ textAlign: "right" }}>
              {showSearchBtn && (
                <Button type="primary" ghost onClick={search}>
                  Search
                </Button>
              )}
              {showResetBtn && <Button onClick={reset}>Reset</Button>}
              <Button onClick={refresh}>Refresh</Button>
              {actions && <Divider type="vertical" />}
              {actions}
            </Col>
          )}
        </Row>
        {!actionsSpan && (
          <Row>
            <Col span={24} style={{ textAlign: "right", paddingBottom: 12 }}>
              {showSearchBtn && (
                <Button type="primary" ghost onClick={search}>
                  Search
                </Button>
              )}
              {showResetBtn && <Button onClick={reset}>Reset</Button>}
              <Button onClick={refresh}>Refresh</Button>
              {actions && <Divider type="vertical" />}
              {actions}
            </Col>
          </Row>
        )}
      </Form>
    </Card>
  );
};
